// polyfill
import 'intersection-observer'
import 'whatwg-fetch'
import streamSaver from 'gyl-common/utils/streamSaver'
import { history } from 'umi'
import { message } from 'antd'
// eslint-disable-next-line no-restricted-imports
import * as antd from 'antd'
import { addQueryToUrl } from '@/utils/url'
import { logger } from '@/utils/logger'
import { initToken } from '@/utils/token'
import { initHostInstance } from '@/utils/hostInstance'
import * as Track from '@/utils/track'
import { autoClearLocalStorageUnusedData } from '@/utils/autoClearLocalCache'

import { startInit } from '@/layouts/GoodsLayout/apis/init'
import proxyConsoleError from '@/utils/proxyConsoleError'
import antdComponentHack from '@/utils/antdComponentHack'
import { initVisitorId } from '@/utils/fingerprint'

antdComponentHack.messageHack(message)
function dasherize(str) {
    return str
        .replace(/(?!^)([A-Z])/g, '-$1')
        .replace(/[-_\s]+/g, '-')
        .toLowerCase()
}

Object.keys(antd).forEach(v => Promise.resolve(require(`antd/es/${dasherize(v)}/style`).default))

autoClearLocalStorageUnusedData()

initVisitorId()
Track.init()
logger.init()

const isProd = PROJECT_CONFIG.mode === 'prod'

if (isProd) {
    proxyConsoleError()
}

streamSaver.mitm = `${PROJECT_CONFIG.publicPath}streamSaver/mitm2024.html`

Promise.all([initHostInstance(), initToken()]).finally(() => {
    const isGoodsTerminal = PROJECT_CONFIG.terminalNameSecond === PROJECT_CONFIG.goodsTerminalName

    if (isGoodsTerminal) {
        startInit()
    }
})

// 承接gyl容器跳转
window.jst_container.tab = {
    open(options = {}) {
        const { url, target, isRefresh, ...state } = options

        if (target === '_blank') {
            window.open(url)

            return
        }

        let newUrl = url
        if (url.startsWith('http')) {
            const urlData = new URL(url)
            newUrl = urlData.pathname + urlData.search
        }

        if (isRefresh) {
            newUrl = addQueryToUrl(newUrl, {
                timestamp: new Date().getTime()
            })
        }

        history.push(newUrl, state)
    }
}
